import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SessionContext } from '../app/contexts/SessionContext';

export const Home = () => {
  const { user } = useContext(SessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!!user) {
      navigate('/app');
    } else {
      navigate('/login');
    }
  }, [user, navigate]);

  return null;
};
